'use strict';

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var utils = require('./utils');

var Plugin = require('./plugin');

module.exports = function (_Plugin) {
  _inherits(MouseEdges, _Plugin);
  /**
   * Scroll viewport when mouse hovers near one of the edges.
   * @private
   * @param {Viewport} parent
   * @param {object} [options]
   * @param {number} [options.radius] distance from center of screen in screen pixels
   * @param {number} [options.distance] distance from all sides in screen pixels
   * @param {number} [options.top] alternatively, set top distance (leave unset for no top scroll)
   * @param {number} [options.bottom] alternatively, set bottom distance (leave unset for no top scroll)
   * @param {number} [options.left] alternatively, set left distance (leave unset for no top scroll)
   * @param {number} [options.right] alternatively, set right distance (leave unset for no top scroll)
   * @param {number} [options.speed=8] speed in pixels/frame to scroll viewport
   * @param {boolean} [options.reverse] reverse direction of scroll
   * @param {boolean} [options.noDecelerate] don't use decelerate plugin even if it's installed
   * @param {boolean} [options.linear] if using radius, use linear movement (+/- 1, +/- 1) instead of angled movement (Math.cos(angle from center), Math.sin(angle from center))
   *
   * @event mouse-edge-start(Viewport) emitted when mouse-edge starts
   * @event mouse-edge-end(Viewport) emitted when mouse-edge ends
   */


  function MouseEdges(parent, options) {
    _classCallCheck(this, MouseEdges);

    var _this = _possibleConstructorReturn(this, (MouseEdges.__proto__ || Object.getPrototypeOf(MouseEdges)).call(this, parent));

    options = options || {};
    _this.options = options;
    _this.reverse = options.reverse ? 1 : -1;
    _this.noDecelerate = options.noDecelerate;
    _this.linear = options.linear;
    _this.radiusSquared = Math.pow(options.radius, 2);

    _this.resize();

    _this.speed = options.speed || 8;
    return _this;
  }

  _createClass(MouseEdges, [{
    key: 'resize',
    value: function resize() {
      var options = this.options;
      var distance = options.distance;

      if (utils.exists(distance)) {
        this.left = distance;
        this.top = distance;
        this.right = window.innerWidth - distance;
        this.bottom = window.innerHeight - distance;
      } else if (!this.radius) {
        this.left = utils.exists(options.left) ? options.left : null;
        this.top = utils.exists(options.top) ? options.top : null;
        this.right = utils.exists(options.right) ? window.innerWidth - options.right : null;
        this.bottom = utils.exists(options.bottom) ? window.innerHeight - options.bottom : null;
      }
    }
  }, {
    key: 'down',
    value: function down() {
      this.horizontal = this.vertical = null;
    }
  }, {
    key: 'move',
    value: function move(e) {
      if (e.data.identifier !== 'MOUSE' || e.data.buttons !== 0) {
        return;
      }

      var x = e.data.global.x;
      var y = e.data.global.y;

      if (this.radiusSquared) {
        var center = this.parent.toScreen(this.parent.center);
        var distance = Math.pow(center.x - x, 2) + Math.pow(center.y - y, 2);

        if (distance >= this.radiusSquared) {
          var angle = Math.atan2(center.y - y, center.x - x);

          if (this.linear) {
            this.horizontal = Math.round(Math.cos(angle)) * this.speed * this.reverse * (60 / 1000);
            this.vertical = Math.round(Math.sin(angle)) * this.speed * this.reverse * (60 / 1000);
          } else {
            this.horizontal = Math.cos(angle) * this.speed * this.reverse * (60 / 1000);
            this.vertical = Math.sin(angle) * this.speed * this.reverse * (60 / 1000);
          }
        } else {
          if (this.horizontal) {
            this.decelerateHorizontal();
          }

          if (this.vertical) {
            this.decelerateVertical();
          }

          this.horizontal = this.vertical = 0;
        }
      } else {
        if (utils.exists(this.left) && x < this.left) {
          this.horizontal = 1 * this.reverse * this.speed * (60 / 1000);
        } else if (utils.exists(this.right) && x > this.right) {
          this.horizontal = -1 * this.reverse * this.speed * (60 / 1000);
        } else {
          this.decelerateHorizontal();
          this.horizontal = 0;
        }

        if (utils.exists(this.top) && y < this.top) {
          this.vertical = 1 * this.reverse * this.speed * (60 / 1000);
        } else if (utils.exists(this.bottom) && y > this.bottom) {
          this.vertical = -1 * this.reverse * this.speed * (60 / 1000);
        } else {
          this.decelerateVertical();
          this.vertical = 0;
        }
      }
    }
  }, {
    key: 'decelerateHorizontal',
    value: function decelerateHorizontal() {
      var decelerate = this.parent.plugins['decelerate'];

      if (this.horizontal && decelerate && !this.noDecelerate) {
        decelerate.activate({
          x: this.horizontal * this.speed * this.reverse / (1000 / 60)
        });
      }
    }
  }, {
    key: 'decelerateVertical',
    value: function decelerateVertical() {
      var decelerate = this.parent.plugins['decelerate'];

      if (this.vertical && decelerate && !this.noDecelerate) {
        decelerate.activate({
          y: this.vertical * this.speed * this.reverse / (1000 / 60)
        });
      }
    }
  }, {
    key: 'up',
    value: function up() {
      if (this.horizontal) {
        this.decelerateHorizontal();
      }

      if (this.vertical) {
        this.decelerateVertical();
      }

      this.horizontal = this.vertical = null;
    }
  }, {
    key: 'update',
    value: function update() {
      if (this.paused) {
        return;
      }

      if (this.horizontal || this.vertical) {
        var center = this.parent.center;

        if (this.horizontal) {
          center.x += this.horizontal * this.speed;
        }

        if (this.vertical) {
          center.y += this.vertical * this.speed;
        }

        this.parent.moveCenter(center);
        this.parent.emit('moved', {
          viewport: this.parent,
          type: 'mouse-edges'
        });
      }
    }
  }]);

  return MouseEdges;
}(Plugin);